import type { FC, SVGProps } from 'react';

export const TrashIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="14"
      height="14"
      fill="currentColor"
      viewBox="0 0 14 14"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill="currentColor"
        d="M9.375 3V1.875H9.5C9.4314 1.87493 9.37515 1.81858 9.375 1.75V1.875H4.625V1.75C4.62485 1.81862 4.56866 1.875 4.5 1.875H4.625V3H9.375ZM3.19531 4.125L3.57324 12.125H10.4268L10.8047 4.125H3.19531ZM12.5 3C12.7766 3 13 3.22344 13 3.5V4C12.9998 4.06862 12.9437 4.125 12.875 4.125H11.9316L11.5459 12.2969C11.5208 12.8311 11.0812 13.25 10.5469 13.25H3.45312C2.92047 13.2499 2.48022 12.8295 2.45508 12.2969L2.06934 4.125H1.125C1.0564 4.12493 1.00015 4.06858 1 4V3.5C1 3.22348 1.2235 3.00007 1.5 3H3.5V1.75C3.5 1.19848 3.9485 0.750069 4.5 0.75H9.5C10.0516 0.75 10.5 1.19844 10.5 1.75V3H12.5Z"
      />
    </svg>
  );
};
